
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.166.833c-2.993 0-5.6 1.88-7 4.667 1.4 2.787 4.007 4.667 7 4.667 2.993 0 5.6-1.88 7-4.667-1.4-2.787-4.007-4.667-7-4.667zm0 7.584a2.916 2.916 0 110-5.833 2.916 2.916 0 010 5.833z"}}),_c('path',{attrs:{"d":"M7.166 7.25a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"}})])
          )
        }
      }
    